import useToast from '@/hooks/useToast';
import { ExternalLinkIcon } from '@chakra-ui/icons';
import { Box, HStack, Text } from '@chakra-ui/react';
import { useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import SvgIcon from '../SvgIcon';
import { svgIconPaths } from '@/assets/svg/icons';
import colors from '@/theme/colors';

const UserProfileBoxInfoPiece = ({
  title,
  text,
  isLink,
  canCopyToClipboard,
}: {
  title: string;
  text: string;
  isLink?: boolean;
  canCopyToClipboard?: boolean;
}) => {
  const toast = useToast();

  const [copied, setCopied] = useState(false);

  const onCopyUrlToClipboard = (copiedText: string) => {
    setCopied(true);
    toast({
      title: 'Text copied to clipboard',
      description: copiedText,
      status: 'success',
      position: 'top-right',
    });

    setTimeout(() => setCopied(false), 5000);
  };

  return (
    <Box gap={0}>
      <Text color={'background.blueGray'} variant={'urbanistExtraBoldSmall'} fontWeight="900">
        {title}
      </Text>
      {isLink ? (
        <a target="_blank" href={text} style={{ fontSize: '14px', fontWeight: 600, textDecoration: 'underline' }}>
          {text}
          <ExternalLinkIcon margin={'4px'} marginTop={'0'} />
        </a>
      ) : (
        <HStack gap={3}>
          <Text color={'text.darkBlue'} variant={'urbanistBold'} marginTop={'4px'} fontWeight={600} noOfLines={1}>
            {text}
          </Text>
          {canCopyToClipboard && (
            <CopyToClipboard text={text} onCopy={(text) => onCopyUrlToClipboard(text)}>
              <button onClick={(e) => e.preventDefault()} style={{ marginLeft: '-2px' }}>
                {copied ? (
                  <SvgIcon
                    iconPath={svgIconPaths.check}
                    color={colors.text.mediumBlue}
                    size={14}
                    boxWidth={12}
                    boxHeight={6}
                  />
                ) : (
                  <SvgIcon iconPath={svgIconPaths.copy} color={colors.text.darkBlue} size={18} boxHeight={14} />
                )}
              </button>
            </CopyToClipboard>
          )}
        </HStack>
      )}
    </Box>
  );
};

export default UserProfileBoxInfoPiece;
